import { Grid, Typography } from '@mui/material';
import InstrumentItem from './InstrumentItem';
import { grey } from '@mui/material/colors';

import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';

interface Props {
  handleInstrumentSelected: (instrumentId: number) => void;
  openConnectDialog: () => void;
  selectedInstrumentId: number;
}

const InstrumentDisplay = ({
  handleInstrumentSelected,
  openConnectDialog,
  selectedInstrumentId,
}: Props) => {
  const { data: analyzers } = useAnalyzers({});

  const instrumentSelected = (instrumentId: number) => {
    handleInstrumentSelected(instrumentId);
  };

  const handleDoubleClick = (instrumentId: number) => {
    handleInstrumentSelected(instrumentId);
    openConnectDialog();
  };

  return (
    <Grid container>
      {analyzers?.length === 0 && (
        <Typography color={grey[500]} sx={{ p: '2rem' }}>
          No analyzers connected.
        </Typography>
      )}
      {analyzers?.map((analyzer) => (
        <Grid item key={analyzer.id} style={{ maxWidth: '8rem' }}>
          <InstrumentItem
            instrument={analyzer}
            onClick={() => instrumentSelected(analyzer.id)}
            onDoubleClick={() => handleDoubleClick(analyzer.id)}
            selected={selectedInstrumentId === analyzer.id}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default InstrumentDisplay;
